import PropTypes from 'prop-types';
import Utils from '@/common/utils/utils';
import Constant  from '@/common/constant/Constant';
import CloseIcon from '@material-ui/icons/Close';
import { removeDrillDownSelectedSearchTime } from '../handler/HelpDeskTicketListHandler';
import { removeDrillDownSelected } from '../handler/KnowledgeTicketHandler';
import { Tooltip } from '@material-ui/core';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import {
    getSelectedDrilldownFieldDisplayLabel,
    getSelectedDrilldownItemDisplayLabel
} from '@/common/utils/DrilldownDisplayUtils';
import tr from '@/common/utils/tr';

HelpdeskListDrilldownSelected.propTypes = {
    drilldownDataSelected: PropTypes.array,
    optionSearchTime: PropTypes.object,
    viewStructure: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    userDetail: PropTypes.object,
};

export default function HelpdeskListDrilldownSelected(props) {
    useTranslationSubscription();
    const { drilldownDataSelected, optionSearchTime, viewStructure, projectInuseDetail, userDetail } = props;

    return (
        <div className="searchCondition">
            {
                !Utils.isEmptyArray(drilldownDataSelected) &&
                    drilldownDataSelected
                        .filter(item => {
                            // filter bookmark of other project
                            if (item.id === Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK){
                                let sharedBookmarkOfView = viewStructure?.sharedBookmark;

                                if (!Utils.isEmptyArray(sharedBookmarkOfView)){
                                    const bookmarkItem = sharedBookmarkOfView?.find(bookmark => bookmark.bookmarkId === item.itemId);
                                    if(!Utils.isEmptyObject(bookmarkItem) && bookmarkItem.projectSelectId !== projectInuseDetail?.id ){
                                        return false
                                    }
                                }
                            };

                            // filter private bookmark
                            if (item.id === Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK){
                                let privateBookmarkOfView = viewStructure.privateBookmark;
                                if (!Utils.isEmptyArray(privateBookmarkOfView)){
                                    const bookmarkItem = privateBookmarkOfView?.find(bookmark => bookmark.bookmarkId === item.itemId);
                                    if (
                                        !Utils.isEmptyObject(bookmarkItem) &&
                                        (bookmarkItem.projectSelectId !==
                                            projectInuseDetail?.id ||
                                            bookmarkItem.userSelectId !== userDetail?.id)
                                    ) {
                                        return false;
                                    }
                                }
                            };

                            return item.isDisplay;
                        })
                        .map(item => {
                            const displayItemLabel = getSelectedDrilldownItemDisplayLabel(item);
                            const displayFieldLabel = getSelectedDrilldownFieldDisplayLabel(item);

                            return (
                                <div className="searchCondition-item" key={`${item.id}${item.itemId}`}>
                                    <span className="close-icon">
                                        <CloseIcon
                                            fontSize="inherit"
                                            onClick={e => removeDrillDownSelected(item, props)}
                                        />
                                    </span>
                                    <Tooltip title={displayItemLabel} arrow={true} placement="left-end">
                                        <span className="itemTagFieldLabel">{displayItemLabel}</span>
                                    </Tooltip>
                                    <span className="option-name">←</span>
                                    <span className="option-name">{displayFieldLabel}</span>
                                </div>
                            );
                        })
            }

            {optionSearchTime && (
                <div className="searchCondition-item" key="optionSearchTime">
                    <span className="close-icon">
                        <CloseIcon
                            fontSize="inherit"
                            onClick={e => removeDrillDownSelectedSearchTime(props)}
                        />
                    </span>
                    <span>{tr(optionSearchTime)}</span>
                </div>
            )}
        </div>
    );
}
